import { useParticipants, useLocalParticipant, useRoomContext } from '@livekit/components-react';
import PanToolIcon from '@material-ui/icons/PanTool';
import { useRaiseHand } from '../../hooks/useRaiseHand';
import { RoomEvent } from 'livekit-client';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateParticipantMetadata } from '../../redux/meeting/actions';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Avatar,
  Typography,
  IconButton,
  ListItemSecondaryAction,
  Tooltip,
} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import DeleteIcon from '@material-ui/icons/Delete'; // For Remove
import MicIcon from '@material-ui/icons/Mic';       // For Unmute (status)
import MicOffIcon from '@material-ui/icons/MicOff'; // For Mute (action/status)
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    removeParticipant,
    muteParticipant,
} from '../../redux/meeting/actions';

const ParticipantOverlay = ({
    open,
    onClose,
    isModerator,
    meetingId,
    // token, // Token is handled by Redux actions
    removeParticipant,
    muteParticipant,
}) => {
  const participants = useParticipants();
//   const participants = participant.flatMap(p =>
//   Array(10).fill(p)
// );
  const room = useRoomContext();
  // eslint-disable-next-line
  const [updater, setUpdater] = useState(0);

  // Force re-render when metadata changes (to show hand icons for remotes)
  useEffect(() => {
     if (!room) return;
     const handleMetadataChange = () => {
         setUpdater(prev => prev + 1);
     };
     room.on(RoomEvent.ParticipantMetadataChanged, handleMetadataChange);
     return () => {
         room.off(RoomEvent.ParticipantMetadataChanged, handleMetadataChange);
     };
  }, [room]);

  const { localParticipant } = useLocalParticipant();
  const { isHandRaised, toggleRaiseHand } = useRaiseHand();

  const handleRemoveParticipant = async (participant) => {
    try {
        if (!meetingId || !participant || !participant.identity) {
            // console.error('Missing meetingId or participant identity');
            return;
        }

        removeParticipant(meetingId, participant.identity);
    } catch (error) {
        // console.error('Failed to remove participant:', error);
    }
  };

  const toggleMute = async (participant) => {
    try {
        // Handle Local Participant
        if (participant.isLocal) {
            const outcome = !localParticipant.isMicrophoneEnabled; 
            await localParticipant.setMicrophoneEnabled(outcome);
            return;
        }

        // Handle Remote Participant (Keep existing logic)
         if (!meetingId || !participant || !participant.identity) {
            // console.error('Missing meetingId or participant identity');
            return;
        }

        const bodyMutedForApi = participant.isMicrophoneEnabled; // If enabled, we want api to mute (true)
        muteParticipant(meetingId, participant.identity, bodyMutedForApi);
        
    } catch (error) {
        // console.error('Failed to mute/unmute participant:', error);
    }
  };
  
  const handleMuteAll = async () => {
     const remoteParticipants = participants.filter(p => !p.isLocal);
     
     // Dispatch actions for all enabled participants
     remoteParticipants.forEach(p => {
         if (p.isMicrophoneEnabled) {
             muteParticipant(meetingId, p.identity, true);
         }
     });
  };

  const getRaisedHands = () => {
      return participants.filter(p => {
          try {
              const md = p.metadata ? JSON.parse(p.metadata) : {};
              return !!md.handRaised;
          } catch (e) { return false; }
      });
  };

  const raisedHandsCount = getRaisedHands().length;
  const unmutedCount = participants.filter(p => !p.isLocal && p.isMicrophoneEnabled).length;
  const dispatch = useDispatch();

  const handleClearAllHands = () => {
      const raisedParticipants = getRaisedHands();

      raisedParticipants.forEach(p => {
            // Update metadata via Backend API
            const currentMetadata = p.metadata ? JSON.parse(p.metadata) : {};
            const newMetadata = { ...currentMetadata, handRaised: false };
            
            dispatch(updateParticipantMetadata(meetingId, p.identity, JSON.stringify(newMetadata)));
      });
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Participants ({participants.length})</span>
        {isModerator && (
             <div style={{ display: 'flex', alignItems: 'center' }}>
             {unmutedCount > 0 && (
                <Button 
                    variant="outlined" 
                    color="secondary" 
                    size="small" 
                    onClick={handleMuteAll}
                    startIcon={<MicOffIcon />}
                >
                    Mute All
                </Button>
             )}
             {raisedHandsCount > 0 && (
                <Button
                    variant="outlined" 
                    color="secondary" 
                    size="small" 
                    onClick={handleClearAllHands}
                    startIcon={<PanToolIcon />}
                    style={{ marginLeft: 8 }}
                >
                    Lower All
                </Button>
             )}
             </div>
        )}
      </DialogTitle>
        <DialogContent dividers style={{ maxHeight: 400, overflowY: 'auto', scrollbarWidth: 'thin' }}>
        <List>
          {participants.map((participant) => {
            const isLocal = participant.isLocal;
            const isMuted = !participant.isMicrophoneEnabled; 
            const metadata = participant.metadata ? JSON.parse(participant.metadata) : {};
            const isRemoteHandRaised = !!metadata.handRaised;
            
            return (
            <ListItem key={participant.identity}>
              <ListItemIcon>
                <Avatar>
                  <PersonIcon />
                </Avatar>
              </ListItemIcon>
              <ListItemText
                primary={
                    <Tooltip title={`${participant.name || participant.identity} ${isLocal ? '(You)' : ''}`}>
                      <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                          <span style={{maxWidth:'50%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                            {participant.name || participant.identity} {isLocal ? '(You)' : ''}
                          </span>
                          {(isLocal ? isHandRaised : isRemoteHandRaised) && (
                              <PanToolIcon style={{ marginLeft: 8, color: '#00bfff', fontSize: 20 }} />
                          )}
                      </div>
                    </Tooltip>
                }
                secondary={isModerator ? (
                    <Tooltip title={participant.identity}>
                      <span style={{ maxWidth: '50%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'block' }}>
                        {participant.identity}
                      </span>
                    </Tooltip>
                ) : null}
              />
              <ListItemSecondaryAction>
                  {/* Raise/Lower Hand (Local Only, Hidden for Moderator) */}
                  {isLocal && !isModerator && (
                      <Tooltip title={isHandRaised ? "Lower Hand" : "Raise Hand"}>
                        <IconButton 
                            edge="end" 
                            onClick={toggleRaiseHand}
                            style={{ marginRight: 8 }}
                        >
                             <PanToolIcon color={isHandRaised ? "primary" : "action"} />
                        </IconButton>
                      </Tooltip>
                  )}

                  {/* Lower Remote Hand (Moderator Only) */}
                  {isModerator && !isLocal && isRemoteHandRaised && (
                       <Tooltip title="Lower Participant's Hand">
                         <IconButton 
                             edge="end" 
                             onClick={() => {
                                 // Moderator lowers remote hand using Backend API
                                 const metadata = participant.metadata ? JSON.parse(participant.metadata) : {};
                                 const newMetadata = { ...metadata, handRaised: false };
                                 dispatch(updateParticipantMetadata(meetingId, participant.identity, JSON.stringify(newMetadata)));
                             }}
                         >
                             <PanToolIcon color="secondary" />
                         </IconButton>
                       </Tooltip>
                   )}

                  {/* Mute Button (Visible to Moderater only for remote, or Self) */}
                  {(isModerator || isLocal) && (
                      <Tooltip title={isMuted ? (isLocal ? "Unmute" : "Cannot unmute others") : "Mute"}>
                        <span>
                            <IconButton 
                                edge="end" 
                                onClick={() => toggleMute(participant)}
                                disabled={!isLocal && isMuted}
                            >
                                {isMuted ? <MicOffIcon color={(!isLocal && isMuted) ? "action" : "error"} /> : <MicIcon />}
                            </IconButton>
                        </span>
                      </Tooltip>
                  )}
                  
                  {/* Remove Button (Visible to Mod only, not for self) */}
                  {isModerator && !isLocal && (
                      <Tooltip title="Remove Participant">
                        <IconButton 
                            edge="end" 
                            aria-label="delete" 
                            onClick={() => handleRemoveParticipant(participant)}
                        >
                            <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                  )}
              </ListItemSecondaryAction>
            </ListItem>
            );
          })}
          {participants.length === 0 && (
             <Typography variant="body2" color="textSecondary" align="center">
                No participants found.
             </Typography>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ParticipantOverlay.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  isModerator: propTypes.bool,
  meetingId: propTypes.string,
  // token: propTypes.string,
  removeParticipant: propTypes.func,
  muteParticipant: propTypes.func,
};

ParticipantOverlay.defaultProps = {
    isModerator: false,
    meetingId: '',
    // token: '',
};

const mapDispatchToProps = {
    removeParticipant,
    muteParticipant,
};

export default connect(null, mapDispatchToProps)(ParticipantOverlay);
